import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getChildbirthOBSelector } from '../selectors'
import { ChildbirthOBConstants } from '../store/childbirthOB.constants'
import { IChildbirthOBState } from '../store/childbirthOB.types'
import {
  saveChildbirthOB,
  setAccelerations,
  setDTR,
  setDeceleration,
  setUCStrength,
  setVariability,
} from '../store/childbirthOB.actions'

export function* setAction() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const childbirthOBState: IChildbirthOBState = yield select(getChildbirthOBSelector)
  const { inputRows } = procedureState
  const { action, variability, accelerations, deceleration, uCStrength, dTR } = childbirthOBState
  if (
    String(action?.id) !== 'Fetal Assessment' &&
    (variability || accelerations || deceleration || uCStrength || dTR)
  ) {
    yield put(setVariability(null))
    yield put(setAccelerations(null))
    yield put(setDeceleration(null))
    yield put(setUCStrength(null))
    yield put(setDTR(null))
    yield put(saveChildbirthOB())
  }
  const keys: string[] = [
    ChildbirthOBConstants.SET_VARIABILITY,
    ChildbirthOBConstants.SET_ACCELERATIONS,
    ChildbirthOBConstants.SET_DECELERATION,
    ChildbirthOBConstants.SET_UC_STRENGTH,
    ChildbirthOBConstants.SET_DTR,
  ]
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (keys.includes(input.key)) {
        input.hidden = String(action?.id) === 'Fetal Assessment' ? false : true
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setActionSaga() {
  yield takeLatest([ChildbirthOBConstants.SET_ACTION, ChildbirthOBConstants.SET_UPDATE_INPUT_ROWS], setAction)
}
